import { Controller, useFormContext } from 'react-hook-form';

import TranslatesWrapper from '../../Translate/TranslatesWrapper';
import type { Language } from '../../Translate/types';

interface Props {
  name: string;
  propertyTranslate: string;
  defaultValues?: Array<Language>;
  availableLanguages: Array<string>;
  defaultLang?: string;
  displayLabel?: string;
  maxLength?: number;
}

const Translable = ({
  name,
  propertyTranslate,
  defaultValues = [],
  availableLanguages,
  defaultLang,
  displayLabel,
  maxLength
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      defaultValue={defaultValues}
      name={name}
      render={({ field }) => {
        const currentValue: Array<Language> = field.value ?? [];

        return (
          <TranslatesWrapper
            key={propertyTranslate}
            availableLanguages={availableLanguages}
            onCreate={(language) => {
              field.onChange([...currentValue, language]);
            }}
            onEdit={(language) => {
              field.onChange(
                currentValue.map((item) =>
                  item.lang === language.lang ? { ...item, value: language.value } : item
                )
              );
            }}
            languages={currentValue}
            defaultLang={defaultLang}
            displayLabel={displayLabel}
            maxLength={maxLength}
          />
        );
      }}
      control={control}
    />
  );
};

export default Translable;
